import { CustomFormFieldType } from '../../../customForms.types';

const humanReadableFormFieldType: Record<CustomFormFieldType, string> = {
  text: 'Short text',
  textarea: 'Long text',
  select: 'List of options',
  attachments: 'Attachments',
  email: 'Email',
  name: 'Name',
  subject: 'Subject',
};

export function getHumanReadableFormFieldType(
  fieldType: CustomFormFieldType | null | undefined,
): string {
  if (!fieldType) return '';

  return humanReadableFormFieldType[fieldType];
}
